import {
  CREATE_SUB_PRACTICE,
  CREATE_SUB_PRACTICE_SUCCESS,
  CREATE_SUB_PRACTICE_FAILURE,
} from 'store/createSubPractice/createSubPracticeAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const createSubPracticeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SUB_PRACTICE:
      return { ...state, loading: true };
    case CREATE_SUB_PRACTICE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case CREATE_SUB_PRACTICE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default createSubPracticeReducer;
